import { PRODUCT_TYPE } from './constants';

export function classifyCartItem(item) {
  const type = item?.type;
  const meta = item?.item || {};

  const isCombo = type === 'combo' || Boolean(meta.is_combo);
  const isPromotional = type === 'promotional' || Boolean(meta.is_promotional);

  let productType = PRODUCT_TYPE.REGULAR;
  if (isCombo) {
    productType = PRODUCT_TYPE.COMBO;
  } else if (isPromotional) {
    productType = PRODUCT_TYPE.PROMOTIONAL;
  }

  return {
    hash: item?.hash,
    type,
    isCombo,
    isPromotional,
    productType,
  };
}

export function summarizeComposition(composition = []) {
  const items = composition.map(classifyCartItem);

  return {
    items,
    hasCombo: items.some(item => item.isCombo),
    hasPromotional: items.some(item => item.isPromotional),
    countByProductType: items.reduce((acc, item) => {
      acc[item.productType] = (acc[item.productType] || 0) + 1;
      return acc;
    }, {}),
  };
}
